import { Input as BaseInput } from 'reactstrap'
import styled, { css } from 'styled-components'

export const styles = css`
  height: 30px;
  padding: 3px 0 0 10px;

  display: flex;
  align-items: center;

  color: #333333;
  font-family: 'Gotham';
  font-size: 14px;
  line-height: 15px;

  border-radius: 4px;
  border: 1px solid #e6e6e6;

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    display: none;
  }
`

const Input = styled(BaseInput)`
  ${styles}
`

export default Input



// WEBPACK FOOTER //
// ./src/lib/components/Input.jsx